import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, MapPin } from 'lucide-react';
const NAMES = ['Brenda M.', 'Carla S.', 'Daiana F.', 'Sofía R.', 'Micaela G.', 'Julieta P.', 'Agustina L.', 'Florencia D.', 'Camila V.', 'Rocío N.', 'Valentina C.', 'Antonella B.', 'Luciana T.', 'Melina A.', 'Yésica O.', 'Abril H.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'La Plata', 'Mendoza', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Resistencia', 'Posadas', 'Bahía Blanca', 'Quilmes', 'San Juan', 'Paraná'];
const OFFERS = ['el KIT Agenda Llena', 'el MEGAPACK PRO'];
type Purchase = {
  id: number;
  name: string;
  city: string;
  offer: string;
};
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
export function PurchaseNotification() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    let nextTimeout: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setCurrent({
        id: Date.now(),
        name: pick(NAMES),
        city: pick(CITIES),
        offer: pick(OFFERS)
      });
      // Keep the toast visible for ~6 seconds
      hideTimeout = setTimeout(() => setCurrent(null), 6000);
      // Schedule the next one between 40 and 60 seconds
      const delay = 40000 + Math.random() * 20000;
      nextTimeout = setTimeout(showOne, delay);
    };
    // First popup after a short initial delay
    const initial = setTimeout(showOne, 8000);
    return () => {
      clearTimeout(initial);
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)]" data-id="element-236">
      <AnimatePresence data-id="element-237">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto flex items-start gap-3 bg-white rounded-2xl shadow-2xl border border-brand-rose p-3.5 pr-5 w-[320px] max-w-full" data-id="element-238">
            <div className="flex-shrink-0 bg-green-100 text-green-600 rounded-full p-2" data-id="element-239">
              <BadgeCheck size={22} data-id="element-240" />
            </div>
            <div className="min-w-0" data-id="element-241">
              <div className="flex items-center gap-1.5" data-id="element-242">
                <span className="text-[11px] font-bold uppercase tracking-wide text-green-600" data-id="element-243">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm text-brand-dark leading-snug mt-0.5" data-id="element-244">
                <span className="font-bold text-brand-burgundy" data-id="element-245">
                  {current.name}
                </span>{' '}
                compró {current.offer}
              </p>
              <div className="flex items-center gap-1 text-xs text-brand-dark/50 mt-1" data-id="element-246">
                <MapPin size={12} className="text-brand-gold" data-id="element-247" />
                <span className="truncate" data-id="element-248">{current.city}, Argentina</span>
                <span className="mx-1" data-id="element-249">·</span>
                <span data-id="element-250">ahora</span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}